module.exports = __webpack_public_path__ + "52678d2dc8473f207b82e1048c1c91f5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-13.png
// module id = 2658
// module chunks = 0